import { useCallback, useState } from 'react';
import { Text, Button, Colors, Icon } from '@mercator-gcp/grout';
import { useNavigate } from 'react-router-dom';
import DeleteProjectGroupModal from 'components/modals/DeleteProjectGroupModal';
import {
  useDashboard,
  useDashboardGroupId,
  useDashboardGroupType,
} from 'state/dashboard';
import { GROUP_TYPE } from 'utils/constants';

const buttonStyle = {
  color: Colors.TextQuiet,
};
const DeleteGroupButton = () => {
  const [groupId] = useDashboardGroupId();
  const [type] = useDashboardGroupType();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const { clearGroup } = useDashboard();
  const navigate = useNavigate();

  const handleDeleteButtonClick = () => {
    setIsDeleteModalOpen(true);
  };

  const handleDeleteSuccess = useCallback(() => {
    clearGroup();
    navigate(`/dashboard/${type === GROUP_TYPE.COMPANY ? 'companies' : 'projects'}`);
  }, [navigate, type]);

  return (
    <>
      <Button
        sx={buttonStyle}
        onClick={handleDeleteButtonClick}
        variant="unstyled"
        startAdornment={<Icon name={Icon.Name.Trash} />}
      >
        <Text>Delete</Text>
      </Button>
      {isDeleteModalOpen && (
        <DeleteProjectGroupModal
          onDeleteCallback={handleDeleteSuccess}
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          groupId={groupId}
        />
      )}
    </>
  );
};

export default DeleteGroupButton;
